module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp23_0.c142a6ae.png";